module.exports = __webpack_public_path__ + "static/media/cerner-bg.ac0da216.png";